// The Call It order for one attempt of a motion Read: random once, then kept
// in this browser so a learner who reloads or comes back mid-Read sees the
// same order. The stored value is also the one to report when analytics is
// added:
//   { order: ["callit-weakening-1", "callit-strengthening-1"], createdAt }
// Storage can be unavailable (private mode, blocked site data); the order is
// then simply random for this visit.

export function loadCallItOrder(ids, key) {
  try {
    const saved = JSON.parse(window.localStorage.getItem(key) || "null");
    if (saved && isPermutation(saved.order, ids)) return saved;
  } catch (e) {
    // fall through to a fresh order
  }
  const record = { order: shuffle(ids), createdAt: new Date().toISOString() };
  try {
    window.localStorage.setItem(key, JSON.stringify(record));
  } catch (e) {
    // not stored; still a valid order for this visit
  }
  return record;
}

// The attempt is over: the next one gets a fresh order.
export function clearCallItOrder(key) {
  try {
    window.localStorage.removeItem(key);
  } catch (e) {
    // nothing to clear
  }
}

function isPermutation(order, ids) {
  return Array.isArray(order) && order.length === ids.length && ids.every((id) => order.includes(id));
}

function shuffle(ids) {
  const a = [...ids];
  for (let i = a.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}
